import React from 'react';
import { DataCard, Label, OverviewHeader } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import FormikRadioGroupYesNo from 'Components/FormikComponents/FormikRadioGroupYesNo';
import { CREATE_VELOCITY_PARAM_INPUTS } from 'Common/parameterEnums';
import styles from './InfoOverview.css';

// TODO: This component is identical to the one in src/coponents/AddRulePage/AddRuleOverview. Refactor!

type Props = Omit<React.ComponentProps<typeof OverviewHeader>, 'children'> & {
    topData?: React.ComponentProps<typeof DataCard>[];
    bottomData?: React.ComponentProps<typeof DataCard>[];
    isSubmitting?: boolean;
    values: ParameterVelocityFormSchema;
    children?: React.ReactNode;
};

const InfoOverview = ({
    leftTitle,
    rightTitle,
    topData,
    bottomData,
    dataTestId,
    children,
    isSubmitting,
    values
}: Props) => {
    const { t } = useTranslation();
    return (
        <OverviewHeader
            dataTestId={dataTestId}
            leftTitle={leftTitle}
            rightTitle={rightTitle}
            containerClassName={styles.overviewHeader}
        >
            {children ? (
                <>{children}</>
            ) : (
                <>
                    <div className={styles.overviewWrapper}>
                        <div className={styles.column}>
                            <div className={styles.card}>
                                {topData?.map((o) => {
                                    return (
                                        <div key={o.label} className={styles.cardRow}>
                                            {o?.data}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className={styles.card}>
                                {bottomData?.map((o) => {
                                    return (
                                        <div key={o.label} className={styles.cardRow}>
                                            {o?.data}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={styles.column}>
                            <div className={styles.columnCard}>
                                <div className={styles.header}>{t('velocityForm.includeCurrentEvent')}</div>
                                <FormikRadioGroupYesNo
                                    name={CREATE_VELOCITY_PARAM_INPUTS.INCLUDE_CURRENT_EVENT}
                                    disabled={isSubmitting}
                                    yesText={t('Yes')}
                                    noText={t('No')}
                                />
                            </div>
                            <div className={styles.columnCard} id={CREATE_VELOCITY_PARAM_INPUTS.UI_TYPE}>
                                <div className={styles.header}>
                                    <Label label={t('Output')} id={CREATE_VELOCITY_PARAM_INPUTS.UI_TYPE} />
                                    <span>
                                        {t('Type')}: {values.type}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </OverviewHeader>
    );
};

export default InfoOverview;
